/*--------------------------------------
 ANIMATIONS
 --------------------------------------*/
Animations = {
    init: function () {
        var controller = new ScrollMagic.Controller();
        //FADEINUP
        $('[data-fadeinup]').each(function () {
            var el = this;
            var tw = gsap.timeline({ paused: true });
            tw.fromTo(el,
                { y: 30 },
                { y: 0, duration: 1, ease: "expo.out" },
                0
            );
            tw.fromTo(el,
                { opacity: 0 },
                { opacity: 1, duration: 1.5, ease: "power1.out" },
                0
            );
            new ScrollMagic.Scene({
                triggerElement: el,
                triggerHook: 0.95,
                reverse: true
            })
                .on("enter", function () {
                    tw.timeScale(1);
                    tw.play();
                })
                .on("leave", function (event) {
                    if (event.scrollDirection === "REVERSE") {
                        tw.timeScale(4);
                        tw.reverse();
                    }
                })
                //.addIndicators()
                .addTo(controller);
        });

        //FADEIN
        $('[data-fadein]').each(function () {
            var el = this;
            var tw = gsap.timeline({ paused: true });
            tw.fromTo(el,
                { opacity: 0 },
                { opacity: 1, duration: 1, ease: "power1.out" },
                0
            );
            new ScrollMagic.Scene({
                triggerElement: el,
                triggerHook: 0.95,
                reverse: true
            })
                .on("enter", function () {
                    tw.timeScale(1);
                    tw.play();
                })
                .on("leave", function (event) {
                    if (event.scrollDirection === "REVERSE") {
                        tw.timeScale(4);
                        tw.reverse();
                    }
                })
                //.addIndicators()
                .addTo(controller);
        });

        //FADEIN
        $('[data-fadeinquik]').each(function () {
            var el = this;
            var tw = gsap.timeline({ paused: true });
            tw.fromTo(el,
                { opacity: 0 },
                { opacity: 1, duration: .5, ease: "power1.out" },
                0
            );
            new ScrollMagic.Scene({
                triggerElement: el,
                triggerHook: 0.95,
                reverse: true
            })
                .on("enter", function () {
                    tw.timeScale(1);
                    tw.play();
                })
                .on("leave", function (event) {
                    if (event.scrollDirection === "REVERSE") {
                        tw.timeScale(4);
                        tw.reverse();
                    }
                })
                //.addIndicators()
                .addTo(controller);
        });

    }
};


/*----------------------
       MENU
---------------------- */
Menu = {
    init: function () {
        $(".section-header .btn-submenu").on("click", function (e) {
            e.preventDefault();
            var parent_this = $(this).closest(".header-menu__nav--lists");
            $('.header-menu__nav--lists').not(parent_this).removeClass('open');
            parent_this.toggleClass("open");
            $("body").removeClass("open-submenu-home");
            $("body").toggleClass("open-submenu");

        });

        $(".section-header-home .btn-submenu").on("click", function (e) {
            e.preventDefault();
            var parent_this = $(this).closest(".header-menu__nav--lists");
            $('.header-menu__nav--lists').not(parent_this).removeClass('open');
            parent_this.toggleClass("open");
            $("body").removeClass("open-submenu");
            $("body").toggleClass("open-submenu-home");
        });



        $("body").on("click", function (e) {
            if (!$(e.target).closest('.btn-submenu, .submenu').length) {
                $('.header-menu__nav--lists').removeClass('open');
                $("body").removeClass("open-submenu");
            }
        });





        $(document).on("scroll", function () {
            if ($(document).scrollTop() > 50) {
                $("body.index .swiper-sliderbig__text").addClass("hide");
                $("body.index .section-header .header-menu__logo__title").addClass("show");
                $("body.index .section-header").addClass("header-black");
            }
            else {
                $("body.index .swiper-sliderbig__text").removeClass("hide");
                $("body.index .section-header .header-menu__logo__title").removeClass("show");
                $("body.index .section-header").removeClass("header-black");
            }
        });
    }
};

/*----------------------
       MENU MOBILE
---------------------- */
MenuMobile = {
    init: function () {
        $(".btn-submenu-mobile").on("click", function (e) {
            e.preventDefault();
            $(this).closest(".header-mobile__nav--lists").toggleClass("open");
        });

        $(".btn-menu-mobile").on("click", function (e) {
            e.preventDefault();
            $("body").toggleClass("open-menu-mobile");
        });

    }
};

/*----------------------
SEARCH
----------------------*/
Search = {
    init: function () {

        //OPEN IN MENU
        $(".section-header .btn-search").on("click", function (e) {
            e.preventDefault();
            $(".section-header .search-input").addClass("open");
            $("body").removeClass("open-search-home");
            $("body").addClass("open-search");
            $(".section-header .search-input input.input-search").val("");
            setTimeout(function () {
                $(".section-header .search-input input.input-search").focus();
            }, 300);
        });

        $(".section-header .search-input input.input-search").on("input", function () {
            $(".section-header .search-input__content").addClass("start");
        });

        //OPEN IN MENU HOME
        $(".section-header-home .btn-search").on("click", function (e) {
            e.preventDefault();
            $(".section-header-home .search-input").addClass("open");
            $("body").removeClass("open-search");
            $("body").addClass("open-search-home");
            $(".section-header-home .search-input input.input-search").val("");
            setTimeout(function () {
                $(".section-header-home .search-input input.input-search").focus();
            }, 300);
        });

        $(".section-header-home .search-input input.input-search").on("input", function () {
            $(".section-header-home .search-input__content").addClass("start");
        });


        //CLOSE
        $(".btn-close-search").on("click", function () {
            $(".search-input").removeClass("open");
            $(".search-input input.input-search").val("");
            $(".search-input__content").removeClass("start");
            $("body").removeClass("open-search");
            $("body").removeClass("open-search-home");
        });

        $("body").on("click", function (e) {
            if (!$(e.target).closest('.btn-search, .search-input').length) {
                $(".search-input").removeClass("open");
                $(".search-input input.input-search").val("");
                $(".search-input__content").removeClass("start");
                $("body").removeClass("open-search");
                $("body").removeClass("open-search-home");
            }
        })
    }
};

$(document).ready(function () {
    Animations.init();
    //Menu.init();
    //Search.init();
    //MenuMobile.init();
});
$(document).on('shopify:section:load', function (event) {
    Animations.init();
});